export default class message {
    _id = '';
    indexId = 0;
    content = '';
    senderId = '';
    username = '';
    avatar = '';
    date = '';
    timestamp = '';
    system = false;
    saved = true;
    distributed = true;
    seen = true;
    deleted = false;
    failure = false;
    disableActions = true;
    disableReactions = true;
    files = null;
    reactions = {}
    replyMessage = null;

    constructor(senderId: string, content: string) {
        this.senderId = senderId;
        this.content = content;
    }
}

